import { useEffect, useState } from "react";
import { Ruler } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { fmtDay } from "@/lib/format";
import { Section } from "@/components/commesse";

const yn = (v) => (v === true ? "sì" : v === false ? "no" : "—");

export const ClientSopralluogo = ({ oid }) => {
  const [list, setList] = useState([]);
  useEffect(() => { api.get(`/client/orders/${oid}/sopralluoghi`).then((r) => setList(r.data)).catch(() => {}); }, [oid]);
  if (!list.length) return null;
  return (
    <Section label="Il tuo sopralluogo" testid="client-sopralluogo">
      <div className="space-y-6">
        {list.map((s) => (
          <div key={s.id} className="space-y-3" data-testid={`client-sopr-${s.id}`}>
            <p className="text-sm text-[#757575]">{fmtDay(s.date)} · {s.address}{s.piano && ` · piano ${s.piano}`} · ascensore {yn(s.ascensore)} · ZTL {yn(s.ztl)}</p>
            {s.ambienti.length > 0 && (
              <div className="rounded-2xl border border-[#EBEBEB] overflow-hidden" data-testid={`client-sopr-misure-${s.id}`}>
                <div className="grid grid-cols-[1fr_auto_auto] gap-x-4 px-4 py-2 bg-[#F7F7F7] rp-label"><span>Ambiente</span><span>Misure (m)</span><span className="text-right">m²</span></div>
                {s.ambienti.map((a, i) => (
                  <div key={i} className="grid grid-cols-[1fr_auto_auto] gap-x-4 px-4 py-2 text-sm border-t border-[#EBEBEB]">
                    <span className="font-medium">{a.nome}</span>
                    <span className="text-[#757575]">{[a.lunghezza, a.larghezza].filter(Boolean).join(" × ") || "—"}{a.altezza ? ` · h ${a.altezza}` : ""}</span>
                    <span className="text-right">{a.mq ?? "—"}</span>
                  </div>
                ))}
                {s.mq_totali > 0 && <div className="flex justify-between px-4 py-2 text-sm font-semibold border-t border-[#EBEBEB]"><span className="flex items-center gap-2"><Ruler className="h-4 w-4" /> Totale</span><span data-testid={`client-sopr-totale-${s.id}`}>{s.mq_totali} m²</span></div>}
              </div>
            )}
            {s.lavori_labels.length > 0 && <p className="text-sm"><span className="text-[#757575]">Lavori previsti:</span> {s.lavori_labels.join(", ")}</p>}
            {s.note && <p className="text-sm whitespace-pre-wrap">{s.note}</p>}
            {s.photos.length > 0 && (
              <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
                {s.photos.map((p) => { const u = fileUrl(`/api/client/orders/${oid}/sopralluoghi/${s.id}/photos/${p.id}`); return <a key={p.id} href={u} target="_blank" rel="noreferrer"><img src={u} alt={p.filename} className="aspect-square w-full rounded-xl object-cover" data-testid={`client-sopr-photo-${p.id}`} /></a>; })}
              </div>
            )}
          </div>
        ))}
      </div>
    </Section>
  );
};
